import React, { useState } from 'react';
import {
  Popover,
  ContextMenuPanel,
  ButtonEmpty,
  Text,
  ContextMenuItem,
  ButtonEmptyProps,
} from '@antoree/ant-ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLanguageContext, LocaleType } from 'contexts/LanguageContext';

export type LanguageSwitcherProps = Pick<ButtonEmptyProps, 'color'>;

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  color = 'ghost',
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const intl = useIntl();

  const { locale, changeLanguage } = useLanguageContext();

  const closeHandler = () => {
    setIsOpen(false);
  };

  const toggleHandler = () => {
    setIsOpen(prevState => !prevState);
  };

  const onLanguageClick = (localeValue: LocaleType) => () => {
    changeLanguage(localeValue);
    closeHandler();
  };

  const button = (
    <ButtonEmpty
      iconType="arrowDown"
      color={color}
      iconSide="right"
      onClick={toggleHandler}
    >
      {locale === 'vi-VN'
        ? intl.formatMessage({ defaultMessage: 'Vietnamese' })
        : null}
      {locale === 'en-US'
        ? intl.formatMessage({ defaultMessage: 'English' })
        : null}
    </ButtonEmpty>
  );

  return (
    <Popover
      button={button}
      isOpen={isOpen}
      closePopover={closeHandler}
      panelPaddingSize="s"
      anchorPosition="downRight"
    >
      <ContextMenuPanel
        size="s"
        items={[
          <ContextMenuItem
            size="m"
            key="vi-vn"
            icon={
              <span role="img" aria-label="vietnam-icon">
                🇻🇳
              </span>
            }
            onClick={onLanguageClick('vi-VN')}
          >
            <Text>
              <p>
                <FormattedMessage defaultMessage="Vietnamese" />
              </p>
            </Text>
          </ContextMenuItem>,
          <ContextMenuItem
            size="m"
            key="en-us"
            icon={
              <span role="img" aria-label="english-icon">
                🇬🇧
              </span>
            }
            onClick={onLanguageClick('en-US')}
          >
            <Text>
              <p>
                <FormattedMessage defaultMessage="English" />
              </p>
            </Text>
          </ContextMenuItem>,
        ]}
      />
    </Popover>
  );
};

export default LanguageSwitcher;
